import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey10 } from 'approot/shared/styles/colours.style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';
import { getBackgroundColour, getFieldHeight } from './response.utils';

type ResponseProps = {
  $baseColour?: string | null;
};

export const ResponseBox = styled.div<ResponseProps>`
  background-color: ${grey1};
  border: 1px solid ${grey10};
  border-radius: ${rem(borderRadius8)};
  position: relative;

  ${({ $baseColour }) =>
    $baseColour &&
    `
      background-color: ${getBackgroundColour($baseColour)};
  `}
`;

type ResponseFieldProps = {
  $baseHeight?: number | null;
};
export const ResponseField = styled.div<ResponseFieldProps>`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}

  border-bottom: 1px solid ${grey10};
  color: ${grey10};
  display: flex;
  align-items: center;
  height: ${({ $baseHeight }) => rem(getFieldHeight(1, $baseHeight))};
  margin-bottom: 0;
  padding: 0 ${rem(spacing16)};

  &:last-child {
    border-bottom: none;
  }
`;

export const ResponseContainer = styled.div`
  ${ResponseBox} {
    margin-bottom: ${rem(spacing8)};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
